<!-- @format -->
<template>
	<div class="pcp-header-menu">
		<el-dropdown @command="handleSelect">
			<div class="pcp-header-user-container">
				<pcp-header-user :show-user-icon="true" />
				{{ globalStore.userInfo?.employee?.name || globalStore.userInfo?.user?.account }}
				<el-icon class="el-icon--right">
					<arrow-down />
				</el-icon>
			</div>
			<template #dropdown>
				<el-dropdown-menu>
					<slot name="menu-front"></slot>
					<el-dropdown-item command="feedback">意见反馈</el-dropdown-item>
					<el-dropdown-item command="editpassword">修改密码</el-dropdown-item>
					<el-dropdown-item command="logout">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</template>
		</el-dropdown>
		<pcp-edit-password-dialog
			:visible="editPasswordVisible"
			title="修改密码"
			:is-reset="false"
			:reg-open="true"
			@close="(visible) => (editPasswordVisible = visible)"
		>
		</pcp-edit-password-dialog>
		<pcp-feedback-dialog
			:visible="editFeedbackVisible"
			title="意见反馈"
			@close="(visible) => (editFeedbackVisible = visible)"
		>
		</pcp-feedback-dialog>
	</div>
</template>

<script setup lang="ts">
	/** @format */

	import { useGlobalStoreWithOut } from '@power/runtime-vue3';
	import PcpHeaderUser from './pcp-header-user.vue';
	import { PcpEditPasswordDialog } from '@/p-components/pcp-editpassword-dialog/index';
	import { PcpFeedbackDialog } from '@/p-components/pcp-feedback-dialog/index';

	const globalStore = useGlobalStoreWithOut();

	const editPasswordVisible = ref(false);
	const editFeedbackVisible = ref(false);

	const handleSelect = (key: string) => {
		if ('logout' === key) {
			globalStore.logOut();
		}
		if ('editpassword' === key) {
			editPasswordVisible.value = true;
		}
		if ('feedback' === key) {
			editFeedbackVisible.value = true;
		}
	};
</script>

<style lang="scss" scoped>
	.pcp-header-menu {
		.pcp-header-user-container {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #fff;
		}
	}
</style>
